import React, { useContext, useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Grid, Card, CardActionArea, CardContent, Typography,
    Chip, Button, Box, Stack, Divider,
    Tooltip,
    TextField,
    MenuItem
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useTheme } from "@emotion/react";
import { tokens } from "../theme";
import axios from "axios";
import { UserContext } from "../context/UserContext";
import ServiceAndBalanceAgreement from "./agreements/ServiceAndBalanceAgreement";
import DistanceSellingAgreement from "./agreements/DistanceSellingAgreement";
import BrandUseAndCreativeGuidelinesProtocol from "./agreements/BrandUseAndCreativeGuidelinesProtocol";
import NotificationAndCommunitactionProtocol from "./agreements/NotificationAndCommunitactionProtocol";
import DataProcessingProtocol from "./agreements/DataProcessingProtocol";
import BrandLegalInfoDialog from "./BrandLegalInfoDialog";

function formatTL(v) {
    if (v == null) return "İletişime geçin";
    return v.toLocaleString("tr-TR") + " TL";
}


function onlyDigits(v = "") { return (v || "").replace(/\D+/g, ""); }

function luhnCheck(num) {
    const s = onlyDigits(num);
    let sum = 0, shouldDouble = false;
    for (let i = s.length - 1; i >= 0; i--) {
        let digit = parseInt(s.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return (sum % 10) === 0;
}

export default function BrandPaywallDialog({ open = true, onClose, onSelect }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.colors);
    const { user, token } = useContext(UserContext);
    const [isLegalInfoDialogOpen, setIsLegalInfoDialogOpen] = useState(!user.legal_name);
    const [openAgreement, setOpenAgreement] = useState({
        serviceAndBalance: false,
        distanceSelling: false,
        brandUseAndCrativeGuidelines: false,
        notificationAndCommunication: false,
        dataProcessing: false,
    });

    const [selectedId, setSelectedId] = useState(1);
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState("select"); // 'select' | 'card' | 'payment_process'
    const [invoiceId, setInvoiceId] = useState(null);
    const [errors, setErrors] = useState({});
    const [card, setCard] = useState({
        holderName: "",
        number: "",
        expMonth: "",
        expYear: "",
        cvv: "",
        installments_number: 0,
    });

    const [agreementsChecked, setAgreementsChecked] = useState({
        serviceAndBalance: false,
        distanceSelling: false,
        protocols: false,
    });

    const packages = user.sales_type === "digital" ? [
        {
            id: 1,
            title: "Başlangıç Modeli (Komisyon Bazlı)",
            priceTL: 0,
            priceNote: "Ön Ödeme: Yok",
            badge: "Komisyon: %10 + KDV",
            perks: [
                "Sınırsız görev & kupon açma hakkı",
                "Kampanya ve entegrasyon desteği",
                "Ürün listeleme desteği",
                "Raporlama + duygu analizi",
                "Not: Hediye medya yoktur."
            ],
            commissionOffset: null,
        },
        {
            id: 2,
            title: "Başlangıç Paketi",
            subtitle: "50.000 TL + KDV Bakiye",
            priceTL: 50000,
            badge: "Hediye: 1 Hafta Açıkhava (1.812 ekran – 12M erişim, ~90.000 TL)",
            perks: [
                "7 gün ana sayfa & kategori görünürlüğü",
                "500 alt reklam gösterimi",
                "3 influencer UGC içerik",
                "Sınırsız görev & kupon açma hakkı",
                "Kampanya ve entegrasyon desteği",
                "Ürün listeleme desteği",
                "Raporlama + duygu analizi",
            ],
            commissionOffset: "Komisyon Mahsuplu: %10 + KDV komisyon satışlardan bu 50K’dan düşer (GMV tavanı ~440K).",
        },
        {
            id: 3,
            title: "Büyüme Paketi",
            subtitle: "110.000 TL + KDV Bakiye",
            priceTL: 110000,
            badge: "Hediye: 1 Hafta Açıkhava (46 ekran – 8M erişim)",
            perks: [
                "14 gün ana sayfa & kategori görünürlüğü",
                "1.500 alt reklam gösterimi",
                "7 influencer UGC içerik",
                "Sınırsız görev & kupon açma hakkı",
                "Kampanya ve entegrasyon desteği",
                "Ürün listeleme desteği",
                "Raporlama + duygu analizi",
            ],
            commissionOffset: "Komisyon Mahsuplu: %10 + KDV komisyon satışlardan bu 110K’dan düşer (GMV tavanı ~1,1M).",
        },
        {
            id: 4,
            title: "Premium Paket",
            subtitle: "187.000 TL + KDV Bakiye",
            priceTL: 187000,
            badge: "Hediye: 1 Hafta Açıkhava (34 ekran – 43M) + 1 Hafta Açıkhava ATM (44 ekran – 27M)",
            perks: [
                "30 gün ana sayfa hero + kategori dominasyonu",
                "3.500 alt reklam gösterimi",
                "20 influencer toplu UGC içerik",
                "Sınırsız görev & kupon açma hakkı",
                "Kampanya ve entegrasyon desteği",
                "Ürün listeleme desteği",
                "Raporlama + duygu analizi",
            ],
            commissionOffset: "Komisyon Mahsuplu: %10 + KDV komisyon satışlardan bu 187K’dan düşer (GMV tavanı ~1,87M).",
            featured: true
        },
    ] : [
        {
            id: 5,
            title: "Komisyon Bazlı Model",
            priceTL: 0,
            priceNote: "Ön Ödeme: Yok",
            badge: "Komisyon: %10 + KDV",
            perks: [
                "100 alt reklam gösterimi",
                "Sınırsız kampanya",
                "Raporlama + duygu analizi",
            ],
            commissionOffset: null,
        },
        {
            id: 6,
            title: "Büyüme Paketi (Tek)",
            subtitle: "50.000 TL + KDV",
            priceTL: 50000,
            badge: "Hediye: 1 Hafta Açıkhava Metro (1.812 ekran – 12M erişim, ~90.000 TL) + 7.500 TL Meta reklam (%15)",
            perks: [
                "Sınırsız kampanya",
                "Raporlama + duygu analizi",
            ],
            commissionOffset: "Komisyon Mahsuplu: %10 + KDV komisyon satışlardan 50K’dan düşer (GMV tavanı ~500K).",
        },
        {
            id: 7,
            title: "Prestij Paketi (Tek)",
            subtitle: "100.000 TL + KDV",
            priceTL: 100000,
            badge: "Hediye: 1 Hafta Seaplay (46 ekran – 8M, ~170K) + 1 Hafta Açıkhava ATM (44 ekran – 27M, ~120K) + 15.000 TL Meta reklam (%15)",
            perks: [
                "Sınırsız kampanya",
                "Raporlama + duygu analizi",
            ],
            commissionOffset: "Komisyon Mahsuplu: %10 + KDV komisyon satışlardan 100K’dan düşer (GMV tavanı ~1M).",
        },
        {
            id: 8,
            title: "Premium Paket (Tek)",
            subtitle: "187.000 TL + KDV",
            priceTL: 187000,
            badge: "Hediye: 1 Hafta Full Network (34 ekran – 43M, ~280K) + 1 Hafta ATM (44 ekran – 27M, ~120K, ücretsiz) + 28.000 TL Meta reklam (%15)",
            perks: [
                "Sınırsız kampanya",
                "İleri raporlama + brand-lift araştırması",
            ],
            commissionOffset: "Komisyon Mahsuplu: %10 + KDV komisyon satışlardan 187K’dan düşer (GMV tavanı ~1,87M).",
        }
    ]

    const openHtmlInNewTab = (html) => {
        const win = window.open("", "_blank");
        if (win) { win.document.open(); win.document.write(html); win.document.close(); }
        else { const div = document.createElement("div"); div.innerHTML = html; document.body.appendChild(div); }
        setStep("payment_process");
    };

    const validateCard = () => {
        const e = {};
        const n = onlyDigits(card.number);
        const m = onlyDigits(card.expMonth);
        const y = onlyDigits(card.expYear);
        const cvv = onlyDigits(card.cvv);

        if (!card.holderName?.trim()) e.holderName = "İsim gerekli";
        if (!n || n.length < 12 || !luhnCheck(n)) e.number = "Geçersiz kart numarası";
        const mi = parseInt(m, 10); if (!m || mi < 1 || mi > 12) e.expMonth = "Ay 01-12 olmalı";
        if (!y || y.length !== 2) e.expYear = "Yıl 2 haneli olmalı (YY)";
        if (!cvv || cvv.length < 3 || cvv.length > 4) e.cvv = "CVV 3-4 hane olmalı";
        if (!agreementsChecked.serviceAndBalance || !agreementsChecked.distanceSelling || !agreementsChecked.protocols) e.agreement = "Devam edebilmek için sözleşmeleri kabul etmelisiniz";

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const callDirect3DInit = async (pkg) => {
        if (!validateCard()) return;

        try {
            setLoading(true);
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}api/alcago/brand/payment/init?token=${token}`,
                {
                    packageId: pkg.id,
                    card: {
                        holderName: card.holderName.trim(),
                        number: onlyDigits(card.number),
                        expMonth: onlyDigits(card.expMonth),
                        expYear: (onlyDigits(card.expYear).length === 4
                            ? onlyDigits(card.expYear).slice(2)
                            : onlyDigits(card.expYear)),
                        cvv: onlyDigits(card.cvv),
                        installments_number: Number(card.installments_number),
                    }
                }
            );

            const data = res.data;
            if (data?.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else if (data?.html) {
                openHtmlInNewTab(data.html);
                setInvoiceId(data.invoice_id);
            } else {
                alert("Ödeme başlatılamadı: yönlendirme bulunamadı.");
            }
        } catch (err) {
            console.error("paySmart3D init error:", err);
            alert("Ödeme başlatılamadı. Lütfen tekrar deneyin.");
        } finally {
            setCard({ holderName: "", number: "", expMonth: "", expYear: "", cvv: "", installments_number: 0 });
            setLoading(false);
        }
    };

    const handleSelect = () => {
        const pkg = packages.find(p => p.id === selectedId);
        if (!pkg || loading) return;

        if (pkg.id === 1 || pkg.id === 5) {
            axios.patch(
                `${process.env.REACT_APP_API_URL}api/alcago/brand/updateBrand?token=${token}&brandId=${user.id}`,
                { brand: { package_type: pkg.id } }).catch(err => {
                    console.error("Package update error:", err);
                    alert("Paket seçimi yapılamadı, lütfen tekrar deneyin.");
                }).finally(() => {
                    window.location.reload();
                });
        } else {
            setStep("card");
        }
    };

    const checkPaymentStatus = async () => {
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/brand/payment/status?token=${token}&invoiceId=${invoiceId}`)
            .then(response => {
                if (response.data?.success && response.data?.payment?.status === "paid") {
                    window.location.reload();
                } else if (response.data?.success && response.data?.payment?.status === "failed") {
                    setStep("failed");
                }
            })
            .catch(error => {
                console.error("Error checking payment status:", error);
            });
    };

    useEffect(() => {
        if (step === "payment_process") {
            const interval = setInterval(() => {
                checkPaymentStatus();
            }, 5000);

            return () => clearInterval(interval);
        }
    }, [step]);

    const renderSelect = () => (
        <>
            <DialogTitle variant="h5">
                Devam etmek için bir paket seçin
                <Typography variant="body2" sx={{ opacity: 0.8, mt: 0.5 }}>KDV ve komisyon detayları pakete göre değişir.</Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    {packages.map((pkg) => {
                        const selected = selectedId === pkg.id;
                        return (
                            <Grid key={pkg.id} item xs={12} sm={6}>
                                <Card variant="outlined" sx={{
                                    height: "100%", borderWidth: selected ? 2 : 1,
                                    borderColor: selected ? colors.primary[400] : colors.grey[400],
                                    boxShadow: selected ? 4 : 0, position: "relative",
                                }}>
                                    {pkg.featured && (
                                        <Chip label="Önerilen" size="small" sx={{ position: "absolute", top: 12, right: 12 }} />
                                    )}
                                    <CardActionArea onClick={() => setSelectedId(pkg.id)} sx={{ height: "100%" }}>
                                        <CardContent sx={{ height: "100%" }}>
                                            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                                {selected ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                                                <Typography variant="h6" sx={{ fontWeight: 700 }}>{pkg.title}</Typography>
                                            </Stack>
                                            {pkg.subtitle && <Typography variant="subtitle2" sx={{ mb: 1 }}>{pkg.subtitle}</Typography>}
                                            <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                                                {pkg.badge && <Tooltip title={pkg.badge}><Chip label={pkg.badge} size="small" /></Tooltip>}
                                            </Stack>
                                            <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1.1, mb: 1 }}>
                                                {pkg.priceTL ? formatTL(pkg.priceTL) : "Ön Ödeme: Yok"}
                                            </Typography>
                                            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
                                                {pkg.priceTL ? "Bakiye + KDV" : "Komisyon Bazlı (%10 + KDV)"}
                                            </Typography>
                                            <Divider sx={{ my: 1.5 }} />
                                            <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                                {pkg.perks.map((perk, i) => (<li key={i}><Typography variant="body2">{perk}</Typography></li>))}
                                            </Box>
                                            {pkg.commissionOffset && (
                                                <Typography variant="caption" sx={{ display: "block", mt: 1.5, opacity: 0.9 }}>
                                                    {pkg.commissionOffset}
                                                </Typography>
                                            )}
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button variant="contained" disabled={!selectedId || loading} onClick={handleSelect}>
                    Devam Et
                </Button>
            </DialogActions>
        </>
    );

    const renderCard = () => {
        const pkg = packages.find(p => p.id === selectedId);
        return (
            <>
                <DialogTitle variant="h6">
                    {/* <Typography variant="h6" sx={{ fontWeight: 700 }}> */}
                    Kart Bilgileri — {pkg?.title}
                    {/* </Typography> */}
                    <Typography variant="body2" sx={{ opacity: 0.8, mt: 0.5 }}>
                        Ödeme 3D Secure ile Sipay üzerinden yapılacaktır.
                    </Typography>
                </DialogTitle>

                <DialogContent dividers>
                    <Stack spacing={2}>
                        <TextField
                            label="Kart Üzerindeki İsim"
                            value={card.holderName}
                            onChange={(e) => setCard({ ...card, holderName: e.target.value })}
                            error={!!errors.holderName} helperText={errors.holderName}
                            fullWidth autoComplete="cc-name"
                        />
                        <TextField
                            label="Kart Numarası"
                            value={card.number}
                            onChange={(e) => setCard({ ...card, number: e.target.value.replace(/[^\d ]/g, "") })}
                            placeholder="4508 0345 0803 4509"
                            inputProps={{ inputMode: "numeric", maxLength: 19, pattern: "[0-9 ]*" }}
                            error={!!errors.number} helperText={errors.number || "Sadece rakam girin"}
                            fullWidth autoComplete="cc-number"
                        />

                        <Stack direction="row" spacing={2}>
                            <TextField
                                label="Ay (MM)" value={card.expMonth}
                                onChange={(e) => setCard({ ...card, expMonth: onlyDigits(e.target.value).slice(0, 2) })}
                                placeholder="12" inputProps={{ inputMode: "numeric", maxLength: 2 }}
                                error={!!errors.expMonth} helperText={errors.expMonth}
                                autoComplete="cc-exp-month"
                            />
                            <TextField
                                label="Yıl (YY)" value={card.expYear}
                                onChange={(e) => setCard({ ...card, expYear: onlyDigits(e.target.value).slice(0, 2) })}
                                placeholder="26" inputProps={{ inputMode: "numeric", maxLength: 2 }}
                                error={!!errors.expYear} helperText={errors.expYear}
                                autoComplete="cc-exp-year"
                            />
                            <TextField
                                label="CVV" value={card.cvv}
                                onChange={(e) => setCard({ ...card, cvv: onlyDigits(e.target.value).slice(0, 4) })}
                                placeholder="000" inputProps={{ inputMode: "numeric", maxLength: 4 }}
                                error={!!errors.cvv} helperText={errors.cvv}
                                autoComplete="cc-csc"
                            />
                            <TextField
                                select label="Taksit" value={card.installments_number}
                                onChange={(e) => setCard({ ...card, installments_number: e.target.value })}
                                sx={{ minWidth: 120 }}
                            >
                                {[0, 1, 2, 3, 6, 9, 12].map(i => <MenuItem key={i} value={i}>{i}</MenuItem>)}
                            </TextField>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                            <input
                                type="checkbox"
                                checked={agreementsChecked.serviceAndBalance}
                                onChange={() => setAgreementsChecked((prev) => ({ ...prev, serviceAndBalance: !prev.serviceAndBalance }))}
                            />
                            <Typography variant="body2">
                                <Button
                                    variant="text"
                                    size="small"
                                    sx={{ color: colors.blueAccent[700], padding: 0, textTransform: "none", minWidth: "unset" }}
                                    onClick={() => setOpenAgreement((prev) => ({ ...prev, serviceAndBalance: true }))}
                                >
                                    Hizmet ve Bakiye Kullanım Sözleşmesi
                                </Button>
                                <span>'ni okudum, anladım ve kabul ediyorum. </span>
                            </Typography>
                            <ServiceAndBalanceAgreement
                                open={openAgreement.serviceAndBalance}
                                onClose={() => setOpenAgreement((prev) => ({ ...prev, serviceAndBalance: false }))}
                                markaUnvan={user.name}
                                markaMersisVno={user.mersis_vno || user.tax_no || "İletişime geçin"}
                                markaAdres={user.company_address || "İletişime geçin"}
                                markaTemsilciAdSoyad={(user.user_name + " " + user.user_surname) || "İletişime geçin"}
                                markaEposta={user.company_email || "İletişime geçin"}
                                markaTel={user.company_phone_number || "İletişime geçin"}
                                paketAdi={pkg?.title || "İletişime geçin"}
                                bakiyeTutari={pkg?.priceTL ? pkg.priceTL.toString() : "0"}
                                urunHizmetAdi="X Ürünü"
                                kullaniciOdemeTutari="999"
                                markaIban={user.iban || "TR00 0000 0000 0000 0000 0000 00"}
                            />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                            <input
                                type="checkbox"
                                checked={agreementsChecked.distanceSelling}
                                onChange={() => setAgreementsChecked((prev) => ({ ...prev, distanceSelling: !prev.distanceSelling }))}
                            />
                            <Typography variant="body2">
                                <Button
                                    variant="text"
                                    size="small"
                                    sx={{ color: colors.blueAccent[700], padding: 0, textTransform: "none", minWidth: "unset" }}
                                    onClick={() => setOpenAgreement((prev) => ({ ...prev, distanceSelling: true }))}
                                >
                                    Mesafeli Satış Sözleşmesi
                                </Button>
                                <span>'ni okudum, anladım ve kabul ediyorum. </span>
                            </Typography>
                            <DistanceSellingAgreement
                                open={openAgreement.distanceSelling}
                                onClose={() => setOpenAgreement((prev) => ({ ...prev, distanceSelling: false }))}
                                markaUnvan={user.name}
                                markaMersisVno={user.mersis_vno || user.tax_no || "İletişime geçin"}
                                markaAdres={user.company_address || "İletişime geçin"}
                                markaTemsilciAdSoyad={(user.user_name + " " + user.user_surname) || "İletişime geçin"}
                                markaEposta={user.company_email || "İletişime geçin"}
                                markaTel={user.company_phone_number || "İletişime geçin"}
                            />
                        </Stack>

                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                            <input
                                type="checkbox"
                                checked={agreementsChecked.protocols}
                                onChange={() => setAgreementsChecked((prev) => ({ ...prev, protocols: !prev.protocols }))}
                            />
                            <Typography variant="body2">
                                <Button
                                    variant="text"
                                    size="small"
                                    sx={{ color: colors.blueAccent[700], padding: 0, textTransform: "none", minWidth: "unset" }}
                                    onClick={() => setOpenAgreement((prev) => ({ ...prev, brandUseAndCrativeGuidelines: true }))}
                                >
                                    Marka Kullanım ve Kreatif Rehber Protokolü
                                </Button>
                                <span>, </span>
                                <Button
                                    variant="text"
                                    size="small"
                                    sx={{ color: colors.blueAccent[700], padding: 0, textTransform: "none", minWidth: "unset" }}
                                    onClick={() => setOpenAgreement((prev) => ({ ...prev, notificationAndCommunication: true }))}
                                >
                                    Tebligat ve Bildirim Protokolü
                                </Button>
                                <span> ve </span>
                                <Button
                                    variant="text"
                                    size="small"
                                    sx={{ color: colors.blueAccent[700], padding: 0, textTransform: "none", minWidth: "unset" }}
                                    onClick={() => setOpenAgreement((prev) => ({ ...prev, dataProcessing: true }))}
                                >
                                    Veri İşleme Protokol
                                </Button>
                                <span>'lerini okudum, anladım ve kabul ediyorum. </span>
                            </Typography>
                            <BrandUseAndCreativeGuidelinesProtocol
                                open={openAgreement.brandUseAndCrativeGuidelines}
                                onClose={() => setOpenAgreement((prev) => ({ ...prev, brandUseAndCrativeGuidelines: false }))}
                                markaUnvan={user.name}
                                markaMersisVno={user.mersis_vno || user.tax_no || "İletişime geçin"}
                                markaAdres={user.company_address || "İletişime geçin"}
                                markaTemsilciAdSoyad={(user.user_name + " " + user.user_surname) || "İletişime geçin"}
                                markaEposta={user.company_email || "İletişime geçin"}
                                markaTel={user.company_phone_number || "İletişime geçin"}
                            />
                            <NotificationAndCommunitactionProtocol
                                open={openAgreement.notificationAndCommunication}
                                onClose={() => setOpenAgreement((prev) => ({ ...prev, notificationAndCommunication: false }))}
                                markaUnvan={user.name}
                                markaMersisVno={user.mersis_vno || user.tax_no || "İletişime geçin"}
                                markaAdres={user.company_address || "İletişime geçin"}
                                markaTemsilciAdSoyad={(user.user_name + " " + user.user_surname) || "İletişime geçin"}
                                markaEposta={user.company_email || "İletişime geçin"}
                                markaTel={user.company_phone_number || "İletişime geçin"}
                            />
                            <DataProcessingProtocol
                                open={openAgreement.dataProcessing}
                                onClose={() => setOpenAgreement((prev) => ({ ...prev, dataProcessing: false }))}
                                markaUnvan={user.name}
                                markaMersisVno={user.mersis_vno || user.tax_no || "İletişime geçin"}
                                markaAdres={user.company_address || "İletişime geçin"}
                                markaTemsilciAdSoyad={(user.user_name + " " + user.user_surname) || "İletişime geçin"}
                                markaEposta={user.company_email || "İletişime geçin"}
                                markaTel={user.company_phone_number || "İletişime geçin"}
                            />
                        </Stack>
                        {errors.agreement && (
                            <Typography variant="caption" color="error">{errors.agreement}</Typography>
                        )}
                    </Stack>
                </DialogContent>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 3, py: 2 }}>
                    <img src="/assets/payment-logos.png" alt="3D Secure" style={{ height: 40, marginLeft: 16, borderRadius: "10px" }} />
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={() => { setStep("select"); setErrors({}); }}>Geri</Button>
                        <Button variant="contained" disabled={loading} onClick={() => callDirect3DInit(pkg)}>
                            {loading ? "Gönderiliyor..." : "Ödemeye Geç"}
                        </Button>
                    </DialogActions>
                </Box>
            </>
        );
    };

    return (
        <Dialog open={open} maxWidth="md" fullWidth onClose={onClose}>
            <BrandLegalInfoDialog
                brandId={user.id}
                open={isLegalInfoDialogOpen}
                onClose={() => { }}
                onUpdate={() => setIsLegalInfoDialogOpen(false)}
            />
            {step === "select" ? renderSelect() : step === "card" ? renderCard() : step === "payment_process" ? (
                <>
                    <DialogTitle>Ödeme İşleniyor...</DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="body2">Ödemeniz işleniyor, lütfen bekleyin. İşlem tamamlandığında otomatik olarak yönlendirileceksiniz.</Typography>
                    </DialogContent>
                </>
            ) : (
                <>
                    <DialogTitle>Ödeme Başarısız</DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="body2">Ödemeniz tamamlanamadı. Lütfen kart bilgilerinizi ve bakiyenizi kontrol edip tekrar deneyin.</Typography>
                        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                            <Button variant="contained" onClick={() => {
                                //refresh page
                                window.location.reload();
                            }}>
                                Tekrar Dene
                            </Button>
                        </Box>
                    </DialogContent>
                </>
            )}
        </Dialog>
    );
}
